module.exports = __webpack_public_path__ + "img/Strelica_narandzasta_gore.8dae4957.svg";